import { render, staticRenderFns } from "./AddEventChairman.vue?vue&type=template&id=c726e3b0"
import script from "./AddEventChairman.vue?vue&type=script&lang=js"
export * from "./AddEventChairman.vue?vue&type=script&lang=js"
import style0 from "./AddEventChairman.vue?vue&type=style&index=0&id=c726e3b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports